<template>
    <div class="card-container">
        <common-top-form :model="formModel" @openAddDialog="changeInfo()" :submitService="submitService"  addShowPower="/tatwithdraw/add" :submitData="submitData" @success="onSuccess">
                <select-organs v-model="formModel.tatSimpleId" :selectValue="formModel.tatSimpleId"></select-organs>
                <!--<el-form-item label="通道名称">-->
                    <!--<el-select v-model="formModel.chnWdId">-->
                        <!--<el-option-->
                            <!--v-for="item in topchnNameList"-->
                            <!--:key="item.id"-->
                            <!--:label="item.chnName"-->
                            <!--:value="item.id">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                <!--</el-form-item>-->
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column prop="tatName" label="机构简称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="chnName" label="通道名称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="excellentFee" label="卓越费率（%）"  min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="rechargeFee" label="充值费率（%）"  min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="upgradeFee" label="升级费率（%）"  min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="evaluationFee" label="卡测评费率（%）"  min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="otherFee" label="其它费率（%）"  min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="updateTime" label="修改时间"  min-width="160"></el-table-column>
            <el-table-column label="操作"  min-width="160" v-if="hasPerm('/tatwithdraw/edit') || hasPerm('/tatwithdraw/delete') || hasPerm('/tatwithdraw/udpStatus')">
                <template slot-scope="scope">
                    <el-button type="text" @click="changeInfo(scope.row)" v-if="hasPerm('/tatwithdraw/edit')">修改</el-button>
                    <el-button type="text" @click="DeleteInfo(scope.row.id)" class="button-color" v-if="hasPerm('/tatwithdraw/delete')">删除</el-button>
                </template>
            </el-table-column>
        </common-table>
        <form-dialog ref="formDialog" :formDialogTitle="formDialogTitle" :model="dialogModel"
                     :dialogService="dialogService" :submitData="dialogData" :rules="dialogRules"
                     @success="dialogSuccess" @close="dialogClose" class="channelRate">
            <select-organs v-model="dialogModel.tatSimpleId" :selectValue="dialogModel.tatSimpleId" :needAll="false" selectWidth="100%"></select-organs>
            <el-form-item label="通道名称" prop="chnWdId">
                <el-select v-model="dialogModel.chnWdId">
                    <el-option
                        v-for="item in chnNameList"
                        :key="item.id"
                        :label="item.chnName"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <div class="flex-row vertical-center flow-start">
                <p class="common-label-text">卓越费率</p>
                <el-form-item label="信用卡配置" prop="excellentFee">
                    <el-input-number :controls="false" v-model="dialogModel.excellentFee1" controls-position="right" :precision="2" :step="0.1" :min="0"></el-input-number>
                    <span>%</span>
                </el-form-item>
                <el-form-item label="支付宝配置" prop="excellentFee">
                    <el-input-number :controls="false" v-model="dialogModel.excellentFee2" controls-position="right" :precision="2" :step="0.1" :min="0"></el-input-number>
                    <span>%</span>
                </el-form-item>
            </div>
            <div class="flex-row vertical-center flow-start">
                <p class="common-label-text">充值费率</p>
                <el-form-item label="信用卡配置" prop="excellentFee">
                    <el-input-number :controls="false" v-model="dialogModel.rechargeFee1" controls-position="right" :precision="2" :step="0.1" :min="0"></el-input-number>
                    <span>%</span>
                </el-form-item>
                <el-form-item label="支付宝配置" prop="excellentFee">
                    <el-input-number :controls="false" v-model="dialogModel.rechargeFee2" controls-position="right" :precision="2" :step="0.1" :min="0"></el-input-number>
                    <span>%</span>
                </el-form-item>
            </div>
            <div class="flex-row vertical-center flow-start">
                <p class="common-label-text">升级费率</p>
                <el-form-item label="信用卡配置" prop="excellentFee">
                    <el-input-number :controls="false" v-model="dialogModel.upgradeFee1" controls-position="right" :precision="2" :step="0.1" :min="0"></el-input-number>
                    <span>%</span>
                </el-form-item>
                <el-form-item label="支付宝配置" prop="excellentFee">
                    <el-input-number :controls="false" v-model="dialogModel.upgradeFee2" controls-position="right" :precision="2" :step="0.1" :min="0"></el-input-number>
                    <span>%</span>
                </el-form-item>
            </div>
            <div class="flex-row vertical-center flow-start">
                <p class="common-label-text">卡测评费率</p>
                <el-form-item label="信用卡配置" prop="excellentFee">
                    <el-input-number :controls="false" v-model="dialogModel.evaluationFee1" controls-position="right" :precision="2" :step="0.1" :min="0"></el-input-number>
                    <span>%</span>
                </el-form-item>
                <el-form-item label="支付宝配置" prop="excellentFee">
                    <el-input-number :controls="false" v-model="dialogModel.evaluationFee2" controls-position="right" :precision="2" :step="0.1" :min="0"></el-input-number>
                    <span>%</span>
                </el-form-item>
            </div>
            <div class="flex-row vertical-center flow-start">
                <p class="common-label-text">其它费率</p>
                <el-form-item label="信用卡配置" prop="excellentFee">
                    <el-input-number :controls="false" v-model="dialogModel.otherFee1" controls-position="right" :precision="2" :step="0.1" :min="0"></el-input-number>
                    <span>%</span>
                </el-form-item>
                <el-form-item label="支付宝配置" prop="excellentFee">
                    <el-input-number :controls="false" v-model="dialogModel.otherFee2" controls-position="right" :precision="2" :step="0.1" :min="0"></el-input-number>
                    <span>%</span>
                </el-form-item>
            </div>
        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import FormDialog from '../../dialog/FormDialog'

    import OrganService from 'service/OrganService'
    import ChannelService from 'service/ChannelService'
    import ChannelCashService from 'service/ChannelCashService'
    import OrganCashService from 'service/OrganCashService'
    import privateKey from 'service/constant/privateKey'
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from 'vuex'
    import SelectOrgans from 'components/business/SelectOrgans'

    export default {
        name: "paymanage",
        data(){
            return{
                formModel:{
                    tatSimpleId:'',
                    chnWdId:'',
                },
                submitService:ChannelCashService.tatPayRateList,
                allChnName: [{
                    id: '',
                    chnName: '全部'
                }],
                chnNameList: [],
                topchnNameList: [],
                page:{},
                tableData:[],
                formDialogTitle:'',
                dialogModel: {
                    tatSimpleId: '',
                    chnWdId: '',
                    excellentFee1: '0',
                    excellentFee2: '0',
                    rechargeFee1: '0',
                    rechargeFee2: '0',
                    upgradeFee1: '0',
                    upgradeFee2: '0',
                    evaluationFee1: '0',
                    evaluationFee2: '0',
                    otherFee1: '0',
                    otherFee2: '0',
                },
                dialogRules:{
                    tatSimpleId: [{
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error('请选择机构简称'))
                            } else{
                                console.log(this.getTatSimpleId == value, this.getTatSimpleId, value)
                                if (this.getTatSimpleId == value){
                                    return callback();
                                }
                                this.checkOnly(value,res =>{
                                    res.contents.checkFlag ? callback(new Error('机构简称不能重复')) : callback()
                                });
                            }
                        },
                    }],
                    chnWdId: [{
                        required: true,
                        message:'请选择通道名称'
                    }]
                },
                cashId:'',
                checkFlag:false,
                getTatSimpleId:'',
                isPage:false,
            }
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        components:{
            CommonTopForm, CommonTable, FormDialog, SelectOrgans
        },
        computed:{
            isExist(){
                return this.checkFlag
            },
            submitData(){
                this.params = {
                    userId: this.userId,
                    tatSimpleId: this.formModel.tatSimpleId,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                return this.params;
            },
            dialogService(){
                if (this.cashId) {
                    return ChannelCashService.tatPayRateEdit;
                } else {
                    return ChannelCashService.tatPayRateAdd;
                }
            },
            dialogData(){
                const params = {
                    userId: this.userId,
                    tatSimpleId: this.dialogModel.tatSimpleId,
                    chnWdId: this.dialogModel.chnWdId,
                    excellentFee: this.dialogModel.excellentFee1 + '/' + this.dialogModel.excellentFee2,
                    evaluationFee: this.dialogModel.evaluationFee1 + '/' + this.dialogModel.evaluationFee2,
                    rechargeFee: this.dialogModel.rechargeFee1 + '/' + this.dialogModel.rechargeFee2,
                    upgradeFee: this.dialogModel.upgradeFee1 + '/' + this.dialogModel.upgradeFee2,
                    otherFee: this.dialogModel.otherFee1 + '/' + this.dialogModel.otherFee2
                };

                if (this.cashId) {
                    params.id = this.cashId
                }

                return params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        mounted(){
            this.page = this.$refs.commonTable.page;
            this.getchnNameList();
            this.getList();
        },
        methods:{
            changeInfo(item){
                this.cashId = item ? item.id : '';
                if (this.cashId) {
                    this.formDialogTitle = "修改";
                    // this.dialogModel = JSON.parse(JSON.stringify(item));
                    this.dialogModel.tatSimpleId = item.tatSimpleId;
                    this.getTatSimpleId = this.dialogModel.tatSimpleId;
                    this.dialogModel.chnWdId = item.chnWdId;
                    this.dialogModel.excellentFee1 = Number(item.excellentFee.split('/')[0]) || 0;
                    this.dialogModel.excellentFee2 = Number(item.excellentFee.split('/')[1]) || 0;
                    this.dialogModel.rechargeFee1 = Number(item.rechargeFee.split('/')[0]) || 0;
                    this.dialogModel.rechargeFee2 = Number(item.rechargeFee.split('/')[1]) || 0;
                    this.dialogModel.upgradeFee1 = Number(item.upgradeFee.split('/')[0]) || 0;
                    this.dialogModel.upgradeFee2 = Number(item.upgradeFee.split('/')[1]) || 0;
                    this.dialogModel.evaluationFee1 = Number(item.evaluationFee.split('/')[0]) || 0;
                    this.dialogModel.evaluationFee2 = Number(item.evaluationFee.split('/')[1]) || 0;
                    this.dialogModel.otherFee1 = Number(item.otherFee.split('/')[0]) || 0;
                    this.dialogModel.otherFee2 = Number(item.otherFee.split('/')[1]) || 0;
                } else {
                    this.getTatSimpleId = '';
                    this.formDialogTitle = "添加";
                }
                this.$refs.formDialog.open();
            },
            getPage(){
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(this.submitService, this.submitData, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.tableData = result.rows;

                        this.page.currentPage = result.current;
                        this.page.pageSize = result.size;
                        this.page.total = result.total;
                        this.isPage = false;
                    });
                }, '信息获取失败')
            },
            onSuccess(res){
                this.doCheck(res, res => {
                    const result = res.contents;
                    this.tableData = result.rows;

                    this.page.currentPage = result.current;
                    this.page.pageSize = result.size;
                    this.page.total = result.total;
                });
            },
            getchnNameList() {
                this.doLoad(ChannelCashService.getAllNames, '', res => {
                    this.doCheck(res, res => {
                        this.chnNameList = res.contents;
                        this.topchnNameList = [...this.allChnName, ...res.contents];
                    });
                }, '信息获取失败')
            },
            dialogSuccess(res){
                this.doCheck(res, res => {
                    const result = res.contents;
                    this.showSuccess(result.optMsg);
                    this.$refs.formDialog.closeDialog();
                    this.getList();
                });
            },
            dialogClose(){
                this.dialogModel = {
                    tatSimpleId: '',
                    chnWdId: '',
                    excellentFee1: '0',
                    excellentFee2: '0',
                    rechargeFee1: '0',
                    rechargeFee2: '0',
                    upgradeFee1: '0',
                    upgradeFee2: '0',
                    evaluationFee1: '0',
                    evaluationFee2: '0',
                    otherFee1: '0',
                    otherFee2: '0',
                };
            },
            doDeleteInfo(id) {
                const disabledParams = {
                    id: id,
                };
                this.doLoad(ChannelCashService.tatPayRateDel, disabledParams, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.showSuccess(result.optMsg);
                        this.getList();
                    });
                }, '操作失败')
            },
            DeleteInfo(id) {
                this.showMsg = '确定删除此通道？';
                this.showConfirm(this.showMsg).then(() => {
                    this.doDeleteInfo(id)
                }).catch(() => {
                });
            },
            checkOnly(val,onSuccess){
                const params = {
                    tatSimpleId:val,
                };
                this.doLoad(ChannelCashService.tatPayRateIsExist,params,res => {
                    this.doCheck(res,res =>{
                        onSuccess && onSuccess(res);
                    });
                },'信息获取失败')
            },
        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/PayManage.vue